import styled, { css } from 'styled-components';

export const TextareaInput = styled.textarea<{
    isDisabled?: boolean;
    isError?: boolean;
}>(
    ({
        isDisabled,
        isError,
        theme: { colors, fontFamily, fontSizes, fontWeight, borderRadius },
    }) => css`
        background: ${colors.app_bg};
        border-radius: ${borderRadius.textarea}px;
        border: 2px solid
            ${isError ? colors.error : colors.transcriptionTextBorder};
        color: ${colors.black};
        font-family: ${fontFamily.secondary};
        font-size: ${fontSizes.f16};
        font-weight: ${fontWeight.light};
        opacity: ${isDisabled ? 0.5 : 1};
        outline: none;
        overflow: hidden;
        resize: none;
        min-height: 96px;
        padding: 16px 60px 16px 16px;
        width: 100%;
        box-sizing: border-box;

        &::-webkit-input-placeholder,
        &::-ms-input-placeholder {
            color: ${colors.placeholder};
        }

        &:active,
        &:focus {
            border-color: ${isError ? colors.error : colors.primary};
        }
    `,
);

export const TextareaWrapper = styled.div<{
    isError?: boolean;
}>(
    ({ isError }) => css`
        align-items: stretch;
        display: flex;
        flex: 1 1 auto;
        flex-direction: column;
        min-width: 0;
        position: relative;
        width: 100%;
        box-sizing: border-box;
        margin: 8px 16px ${isError ? '20px' : '16px'};
    `,
);

export const TextareaEditIconWrapper = styled.div`
    position: absolute;
    right: 12px;
    top: 8px;
    z-index: 1;
`;

export const TextareaSendIconWrapper = styled.div`
    position: absolute;
    right: 40px;
    top: 9px;
    z-index: 1;
`;

export const TextareaTimeWrapper = styled.div(
    ({ theme: { fontSizes, colors } }) =>
        css`
            background: ${colors.app_bg};
            font-size: ${fontSizes.f12};
            font-weight: 500;
            left: 25px;
            line-height: 17px;
            padding: 0 12px;
            position: absolute;
            top: -7px;
            z-index: 1;

            input {
                border: 1px solid ${colors.inputBorder};
            }
        `,
);
